const templates = {
  createATemplate: 'Créer un modèle',
  noTemplatesToDisplay: 'Aucun modèle à afficher',
  template: 'Modèle',
  templates: 'Modèles',
};

export default templates;
